<template>
    <el-container @click="drawer = false">
        <AppHeader @toggle-menu="drawer = !drawer" />
        <el-container>
            <AppMenu :open-menu="drawer" @toggle-menu="toggleMenu" />
            <el-main class="app-main">
                <ErrorAlert />
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script lang="ts">
import AppHeader from '@/components/AppHeader.vue';
import AppMenu from '@/components/AppMenu.vue';
import ErrorAlert from '@/components/ErrorAlert.vue';
import { defineComponent, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const Entered = defineComponent({
    components: { ErrorAlert, AppHeader, AppMenu },
    setup() {
        const route = useRoute();
        const store = useStore();

        watch(
            () => route.meta,
            () => {
                store.commit('errors/RESET_ERROR_MESSAGE');
            },
            { immediate: true, deep: true },
        );

        return {};
    },
    data() {
        return {
            drawer: false,
        };
    },
    methods: {
        toggleMenu(toggle: boolean) {
            this.drawer = toggle;
        },
    },
});
export default Entered;
</script>
